import { Component, Input } from '@angular/core';

@Component({
    selector: 'header',
    templateUrl: './header.component.html',
    styleUrls: ['header.component.css'],
    standalone: false
})
export class HeaderComponent {
    @Input() public brandImage: string = "../../../assets/common/header/logo-randstad.png";
    @Input() public brandImageAlt: string = "Randstad";
    @Input() public enableImpersonation: boolean = false;
    @Input() public disableMobileMenu: boolean = false;
    public showMobileMenu: boolean = false;
}